// ABOUTME: A business row's "…" menu in the Agents tree: Rename (admins), Settings, and Delete
// for the owner of any business but Maxflow's own house business.
import { MoreHorizontal, Pencil, Settings, Trash2 } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import type { Business } from '@/stores/useMyBusinessStore'

// Phone tap targets are at least 44 px.
const ITEM = 'max-md:min-h-11'

interface BusinessRowMenuProps {
  business: Business
  onRename: () => void
  onSettings: () => void
  onDelete: () => void
}

export function BusinessRowMenu({
  business,
  onRename,
  onSettings,
  onDelete,
}: BusinessRowMenuProps) {
  const canRename = business.role === 'owner' || business.role === 'admin'
  const canDelete = business.role === 'owner' && !business.is_house

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`${business.name} options`}
          data-testid={`business-menu-${business.id}`}
          className="text-muted-foreground hover:text-foreground flex size-11 shrink-0 items-center justify-center rounded-lg md:size-8"
        >
          <MoreHorizontal className="size-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {canRename && (
          <DropdownMenuItem onSelect={onRename} data-testid="business-menu-rename" className={ITEM}>
            <Pencil className="size-4" />
            Rename
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onSelect={onSettings}
          data-testid="business-menu-settings"
          className={ITEM}
        >
          <Settings className="size-4" />
          Settings
        </DropdownMenuItem>
        {canDelete && (
          <DropdownMenuItem
            variant="destructive"
            onSelect={onDelete}
            data-testid="business-menu-delete"
            className={ITEM}
          >
            <Trash2 className="size-4" />
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
